"use strict";

angular.module("core")
.component("invoiceAttachmentLink", {
    templateUrl: require("./invoice-attachment-link.component.html"),
    controller: InvoiceAttachmentLinkController,
    controllerAs: "invoiceAttachmentLinkCtrl",
    bindings: {
        invoice: "<",
        onAddAttachment: "&", // Param: invoiceId
        readOnly: "<?"
    }
});

function InvoiceAttachmentLinkController($scope, semver, UserService, MOBILE_APP_VERSION, INVOICE_ATTACHMENTS_MAX) {
    var supportsImageUpload = !MOBILE_APP_VERSION || semver.gte(MOBILE_APP_VERSION, "0.1.4")
    UserService.isUserFetched().then(function onSuccess(user) {
        $scope.canAddAttachment = !!user && !!user.dedicated_vendor_id && supportsImageUpload;
    });

    this.isReadOnly = function() {
        return this.readOnly || (this.invoice.attachments_count === 0 && !$scope.canAddAttachment);
    };

    this.canAddAttachments = function() {
        return !this.readOnly && this.invoice.attachments_count === 0 && $scope.canAddAttachment;
    };

    this.canOnlySeeAttachments = function() {
        return !this.readOnly && this.invoice.attachments_count > 0 || (
            !this.readOnly
            && this.invoice.attachments_count > 0
            && this.invoice.attachments_count <= INVOICE_ATTACHMENTS_MAX
            && !$scope.canAddAttachment
        );
    };
}



//////////////////
// WEBPACK FOOTER
// ./core/invoice-attachment/invoice-attachment-link.component.js
// module id = 634
// module chunks = 0